// extracted by css-extract-rspack-plugin
export default {"trailingRow":"ly4ApJvMzsIJPnvi","root":"dmpSrPUlFn44sqMf","container":"_L26oJyc1csOk0eV"};